export default __webpack_public_path__ + "static/VeryConfident-eeeb3a90a5b1236a13fd5360ff6a86cd.svg";